module.exports = __webpack_public_path__ + "static/media/STEP3.c758b272.png";